// Mapa de campanhas
export const CAMPANHAS = {
  doenca: { label: 'Auxílio Doença',    bg: 'var(--camp-doenca-bg)', text: 'var(--camp-doenca-text)' },
  acid:   { label: 'Aux. Acidente',     bg: 'var(--camp-acid-bg)',   text: 'var(--camp-acid-text)'   },
  vinc:   { label: 'Vínculo Empreg.',   bg: 'var(--camp-vinc-bg)',   text: 'var(--camp-vinc-text)'   },
  bpc:    { label: 'BPC Loas',          bg: 'var(--camp-bpc-bg)',    text: 'var(--camp-bpc-text)'    },
  mat:    { label: 'Sal. Maternidade',  bg: 'var(--camp-mat-bg)',    text: 'var(--camp-mat-text)'    },
  com:    { label: 'Comercial',         bg: 'var(--camp-com-bg)',    text: 'var(--camp-com-text)'    },
};

export const STATUS = {
  aguardando:      { label: 'Aguardando',       bg: 'var(--waiting-bg)',  text: 'var(--waiting-text)'  },
  em_atendimento:  { label: 'Em atendimento',   bg: 'var(--active-bg)',   text: 'var(--active-text)'   },
  pendente:        { label: 'Pendente',          bg: 'var(--pending-bg)',  text: 'var(--pending-text)'  },
  resolvida:       { label: 'Resolvida',         bg: 'var(--resolved-bg)', text: 'var(--resolved-text)' },
};

// Gera iniciais do nome
export function iniciais(nome = '') {
  return nome.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

// Paleta de avatares
const AV = [
  { bg: '#fff1ee', color: '#9a3412' },
  { bg: '#f0edff', color: '#4c1d95' },
  { bg: '#ecfdf5', color: '#065f46' },
  { bg: '#fffbeb', color: '#78350f' },
  { bg: '#fdf2f8', color: '#831843' },
  { bg: '#eff6ff', color: '#1e3a8a' },
  { bg: '#f0fdf4', color: '#166534' },
  { bg: '#fefce8', color: '#713f12' },
];
export function avColor(index) {
  return AV[index % AV.length];
}

// Formata horário
export function hora(dataStr) {
  if (!dataStr) return '';
  const d = new Date(dataStr);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

// Formata data relativa
export function dataRelativa(dataStr) {
  if (!dataStr) return '';
  const d    = new Date(dataStr);
  const hoje = new Date();
  const diff = Math.floor((hoje - d) / 86400000);
  if (diff === 0) return hora(dataStr);
  if (diff === 1) return 'Ontem';
  if (diff < 7)  return d.toLocaleDateString('pt-BR', { weekday: 'short' });
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}
